import { render, staticRenderFns } from "./KeranjangView.vue?vue&type=template&id=6a958756&scoped=true"
import script from "./KeranjangView.vue?vue&type=script&lang=js"
export * from "./KeranjangView.vue?vue&type=script&lang=js"
import style0 from "./KeranjangView.vue?vue&type=style&index=0&id=6a958756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a958756",
  null
  
)

export default component.exports